import { useEffect, useRef } from 'react';

const useAutoSave = (key, data, debounceTime = 500, processData = null) => {
  const timerRef = useRef(null);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      try {
        const dataToSave = processData ? processData(data) : data;
        sessionStorage.setItem(key, JSON.stringify(dataToSave));
        //const savedData = sessionStorage.getItem(key);
        //console.log(`Auto-saved to '${key}':`, savedData);
        
      } catch (error) {
        console.error(`Error auto-saving to '${key}':`, error);
      }
    }, debounceTime);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [key, data, debounceTime, processData]);
};

export default useAutoSave;